export class LoginRequest {
  constructor(public username?: string | null, public password?: string | null) {
  }
}
